import Toastify from "toastify-js";

class Notify {
  emit(notifications) {
    Object.values(notifications).forEach((notification) => {
      let backgroundColor = "";
      let className = "";

      switch (notification.status) {
        case "success":
          backgroundColor = "#004B89";;
          className = "bg-dark-grass text-dark-black bg-classic-white text-classic-primary bg-pride-cherry text-pride-white bg-pastel-cherry-light text-pastel-black";
          break;
        default:
          backgroundColor = "#E74C3C";
          break;
      }

      Toastify({
        text: notification.message,
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom",
        position: "right",
        backgroundColor: backgroundColor,
        className,
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });
  }
}

export default Notify;
